import { firstBy } from 'thenby'

export default function (courts) {
  courts = [...new Set(courts)].filter(f => !!f)
  const num = courts.filter(f => !/\D/.test(f)).sort((a, b) => a - b)
  const nonNum = courts.filter(f => /\D/.test(f)).sort(firstBy((a, b) => b - a).thenBy((a, b) => (+a.replace(/\D/g, '')) - (+b.replace(/\D/g, ''))))
  return [...num, ...nonNum]
}
